var map = {
	"./2023/autumn/poster/today_area_best_team.png": "5245",
	"./2023/summer/poster/today_area_best_team.png": "9961",
	"./2024/autumn/poster/today_area_best_team.png": "8a35",
	"./2024/summer/poster/today_area_best_team.png": "da87",
	"./2024/winter/poster/today_area_best_team.png": "beca",
	"./2025/spring/poster/today_area_best_team.png": "536d",
	"./2025/summer/poster/today_area_best_team.png": "e965",
	"./2025/winter/poster/today_area_best_team.png": "b5bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1740";